<template>
    <div class="flex flex-row-reverse justify-end gap-4 font-semibold">
        <span>{{ label }}</span>
        <div class="flex items-center gap-x-3">
            <label for="toggle" class="relative inline-block w-9 h-5 cursor-pointer">
                <input type="checkbox" id="toggle" class="peer sr-only" :checked="modelValue" @change="handleChange">
                <span class="absolute inset-0 border-1 border-slate-500 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-blue-600 dark:bg-neutral-700 dark:peer-checked:bg-blue-500 peer-disabled:opacity-50 peer-disabled:pointer-events-none"></span>
                <span class="absolute top-1/2 start-0.5 -translate-y-1/2 size-4 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full dark:bg-neutral-400 dark:peer-checked:bg-white"></span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ItemToggle', 
    props: {
        label: String,
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const handleChange = (event) => {
            const value = event.target.checked            
            emit('update:modelValue', value)
        }
        
        return {
            handleChange
        }
    },
    emits: ['update:modelValue']
}
</script>